import React, { useMemo, useRef } from 'react';
import cx from 'classnames';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import Dropdown from '@components/@core/Dropdown';
import Tabs from '@components/@core/Tabs';

const ResponsiveTabs = ({ className = '', active, type = 'white', welcome = null, data = [], getId = (e) => e?.id, getValue = (e) => e?.name, onTab = () => {} }) => {
    const container = useRef();

    const [tabs, desktop] = useMemo(() => {
        let _desktop = true;
        const tab = [];
        const dropdown = [];
        const tabList = welcome ? [{ type: 'tab', data: welcome }] : [];
        let name = 'All';
        const text = document.createElement('span');
        document.body.appendChild(text);

        // text.style.font = "times new roman"
        text.style.fontSize = 14 + 'px';
        text.style.height = 'auto';
        text.style.width = 'auto';
        text.style.position = 'absolute';
        text.style.whiteSpace = 'nowrap';

        for (const item of data) {
            name += 'AAA/AAA' + item.name;
            text.innerHTML = name;
            const textWidth = Math.ceil(text.clientWidth);
            const contentWidth = container?.current?.offsetWidth ?? 914;
            if (textWidth > contentWidth - 140) {
                _desktop = false;
                dropdown.push(item);
            } else {
                tab.push(item);
            }
        }

        document.body.removeChild(text);

        tab.forEach((item) => {
            tabList.push({ type: 'tab', data: item });
        });
        if (dropdown.length > 0) {
            const activated = find(propEq('id', active), tab);
            if (activated || active === 'all') {
                tabList.push({ type: 'tab', data: dropdown[0] });
                if (dropdown.length > 1) {
                    tabList.push({ type: 'dropdown', name: 'fas fa-ellipsis', data: dropdown.slice(1) });
                }
            } else {
                const _activated = find(propEq('id', active), dropdown);
                if (_activated) {
                    tabList.push({ type: 'tab', data: _activated });
                    if (dropdown.length > 1) {
                        tabList.push({ type: 'dropdown', name: 'fas fa-ellipsis', data: filter((x) => x.id !== active, dropdown) });
                    }
                }
            }
        }
        return [tabList, _desktop];
    }, [active, data]);

    return (
        <div className={`bg-white tab-container ${className}`} ref={container}>
            <Tabs className={cx(!desktop && 'desktop-screen')} active={active} type={type} data={tabs} getId={getId} getValue={getValue} onTab={onTab} />
            {!desktop && <Dropdown className="mobile-screen" data={data} defaultIds={[active]} returnBy="data" getId={getId} getValue={getValue} onChange={(e) => onTab(e[0])} />}
        </div>
    );
};

export default ResponsiveTabs;
